import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { App } from "./App";
import { tg } from "./telegram";
import "./styles.css";

const MANIFEST_URL = "https://graffiti.easyproxynetwork.online/tonconnect-manifest.json";

tg?.ready();
tg?.expand();
// Stop Telegram from minimising the app on a downward swipe — critical for
// drawing, where vertical finger motion must paint, not close the window.
tg?.disableVerticalSwipes?.();

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <TonConnectUIProvider manifestUrl={MANIFEST_URL}>
        <App />
      </TonConnectUIProvider>
    </StrictMode>,
  );
}
